import React from 'react'
import { AdminHomeMetric } from '../../types/AdminHomeMetric'
import { DashCard } from '../DashCard'


export const AdminHomeMetrics = ({ metric,load }: Props) => {
    return (
        <div className="grid grid-cols-4 gap-x-4 mt-4">
            <DashCard name="Organizações cadastradas" number={metric.total_osc} load={load}/>
            <DashCard name="Número de municípios " number={metric.total_city} important load={load}/>
            <DashCard name="Testes respondidos " number={metric.total_diagnoses} important load={load}/>
            <DashCard name="Responderam tudo" number={metric.total_reply} load={load}/>
        </div>
    )
}

interface Props {
    metric: AdminHomeMetric
    load?:boolean
}
